import { Pipe, PipeTransform } from "@angular/core";
import { BOIType } from "../interfaces";
import { getOwnerType } from "../utils/owner-helpers";

@Pipe({
  name: 'ownerType',
})
export class OwnerTypePipe implements PipeTransform {
  transform(isEntity: boolean | null, boiType = BOIType.BENEFICIAL_OWNER): string {
    if (isEntity === null || (!isEntity && !boiType)) {
      return "";
    }

    return getOwnerType(
      isEntity,
      boiType
    );
  }
}
